import { render, staticRenderFns } from "./FeedVideo.vue?vue&type=template&id=4278634a&"
import script from "./FeedVideo.vue?vue&type=script&lang=js&"
export * from "./FeedVideo.vue?vue&type=script&lang=js&"
import style0 from "./FeedVideo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports